<template>
  <v-layout column>
    <v-layout row-wrap justify-space-between>

      <v-flex>
        <EmployeeSelect label="Standing" fieldName="standing" :object="employee" :items="standings"/>
        <EmployeeSelect label="Status" fieldName="status" :object="employee" :items="statuses"/>
      </v-flex>

      <v-flex class="ml-2">
        <EmployeeSelect
          autocomplete
          label="Hour Cap"
          fieldName="hour_cap"
          :object="employee"
          :items="hours"
        />
        <EmployeeSelect label="Priority" fieldName="employee_priority" :object="employee" :items="priorities"/>
      </v-flex>
    </v-layout>

    <v-layout column class="mt-4">
      <v-flex>
        <h3>Message preferences</h3>
      </v-flex>
      <v-layout row justify-start v-for="(setting, key) in messagePreferences" :key="key">
          <v-flex >
            <v-checkbox
              :label="`${ preferenceLabel(key) } (manager override)`"
              v-model="setting.managerOverride"
              @change="updateMessagePreferences"
            />
          </v-flex>
          <v-flex >
            <v-checkbox
              :label="`${ preferenceLabel(key) } (user's setting)`"
              v-model="setting.userSetting"
              disabled
            />
          </v-flex>
      </v-layout>
    </v-layout>

    <v-layout column class="mt-4">
      <v-flex v-if="!employee.deactivated">
        <v-dialog v-model="deactivateModal" max-width='300'>
          <v-btn color="error" slot="activator">Deactivate User</v-btn>
          <v-card>
            <v-card-title>
              <h2 class="headline">Deactivate User?</h2>
            </v-card-title>
            <v-card-text>
              <p>This will deactivate {{ employee.email }}. This means they will
              no longer be able to log in, and their name will not appear as an
              option for client coordinated coverage, as an in-app message
              recipient, or a potential guest for Events.</p>
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn color="grey" flat @click="deactivateModal = false">Nevermind</v-btn>
              <v-btn color="success" :disabled="deactivatePending" :pending="deactivatePending" @click="deactivate">Deactivate</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>

      <v-flex v-else>
        <v-dialog v-model="reactivateModal" max-width='300'>
          <v-btn color="success" slot="activator">Reactivate User</v-btn>
          <v-card>
            <v-card-title>
              <h2 class="headline">Reactivate User?</h2>
            </v-card-title>
            <v-card-text>
              <p>This will reactivate {{ employee.email }}. They will once again
              be eligible for messages, coordinated coverage and event RSVPs.
              You'll need to reset their password and send it to them after
              reactivating here.</p>
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn color="grey" flat @click="reactivateModal = false">Nevermind</v-btn>
              <v-btn color="success" :disabled="reactivatePending" :pending="reactivatePending"  @click="reactivate">Reactivate</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import EmployeeSelect from '@/components/hr/employee-select.vue'
import EmployeeField from '@/components/hr/employee-field.vue'
import EmployeeDateField from '@/components/hr/employee-date-field.vue'
import EmployeeCheckboxField from '@/components/hr/employee-checkbox-field.vue'

export default {
  components: {
    EmployeeSelect,
    EmployeeField,
    EmployeeDateField,
    EmployeeCheckboxField,
  },

  data() {
    return {
      priorities: [1,2,3,4,5],
      deactivateModal: false,
      deactivatePending: false,
      reactivateModal: false,
      reactivatePending: false,
    }
  },

  computed: {
    standings: function() {
      return this.$store.state.employees.possibleStandings
    },
    statuses: function() {
      return this.$store.state.employees.possibleStatuses
    },
    hours: function() {
      return Array.from(Array(61).keys())
    },
    messagePreferences() {
      // Employee does not have priveleges to set pickup preference
      // Only a client can
      delete this.employee.profile.message_preferences.pickup;

      return this.employee.profile.message_preferences;
    },
  },

  methods: {
    deactivate() {
      this.deactivatePending = true;
      this.$store.dispatch("employees/deactivate", {
        id: this.employee.id
      }).then(() => {
        this.deactivatePending = false;
        this.deactivateModal = false;
      })
      return;
    },

    reactivate() {
      this.reactivatePending = true;
      this.$store.dispatch("employees/reactivate", {
        id: this.employee.id
      }).then(() => {
        this.reactivatePending = false;
        this.reactivateModal = false;
      })
      return;
    },

    updateMessagePreferences() {
      this.$store.dispatch("employees/managerSetEmployeeProfilePreferences", {
        id: this.employee.id,
        profile: this.employee.profile,
      }).then(employee => {
        this.$store.dispatch('employees/getEmployee', this.employee.id)

        this.$store.dispatch("global/showSnackbarSuccess", { message: "Message preferences updated" })
      })
      .catch(e => {
        this.$store.dispatch("global/showSnackbarError", { message: "Something went wrong" })
      })
    },

    preferenceLabel(key) {
      switch(key.toString()) {
        case 'global':
          return "Global: receive emails";
        case 'shiftReminder':
          return "Shift reminders";
        case 'important':
          return "Important and time-sensitive messages";
        case 'default':
          return "All other messages";
      }
    },
  },

  props: [
    'employee'
  ],
}
</script>
